import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private _snackBar = inject(MatSnackBar);

  handleError(error: Error): void {

    if (error instanceof HttpErrorResponse) {
      if (error.status === 409 && !!error.error.message) {
        this._snackBar.open(error.error.message.fr, 'OK', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
      } else {
        console.log(error);
        this._snackBar.open('Une erreur est survenue', 'OK', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
      }
    }
  }
}